var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3644 6.22585C17.1928 5.05427 15.2933 5.05427 14.1218 6.22585L12.7076 7.64006C12.317 8.03059 11.6839 8.03059 11.2933 7.64006C10.9028 7.24954 10.9028 6.61637 11.2933 6.22585L12.7076 4.81163C14.6602 2.85901 17.826 2.85901 19.7786 4.81163C21.7312 6.76426 21.7312 9.93008 19.7786 11.8827L18.3644 13.2969C17.9739 13.6874 17.3407 13.6874 16.9502 13.2969C16.5597 12.9064 16.5597 12.2732 16.9502 11.8827L18.3644 10.4685C19.536 9.29692 19.536 7.39742 18.3644 6.22585ZM15.5362 9.05446C15.9267 9.44499 15.9267 10.0782 15.5362 10.4687L9.87933 16.1255C9.48881 16.5161 8.85565 16.5161 8.46512 16.1255C8.0746 15.735 8.0746 15.1018 8.46512 14.7113L14.122 9.05446C14.5125 8.66394 15.1457 8.66394 15.5362 9.05446ZM7.05071 11.8827C7.44123 12.2732 7.44123 12.9064 7.05071 13.2969L5.63649 14.7111C4.46492 15.8827 4.46492 17.7822 5.63649 18.9538C6.80806 20.1253 8.70756 20.1253 9.87913 18.9538L11.2933 17.5396C11.6839 17.149 12.317 17.149 12.7076 17.5396C13.0981 17.9301 13.0981 18.5632 12.7076 18.9538L11.2933 20.368C9.34072 22.3206 6.1749 22.3206 4.22228 20.368C2.26966 18.4154 2.26966 15.2495 4.22228 13.2969L5.63649 11.8827C6.02702 11.4922 6.66018 11.4922 7.05071 11.8827Z",
    fill: "#0E1426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/iconLink.d6700a1d9d2493c50cd013edde0e1ef5.svg";
export { ForwardRef as ReactComponent };